// 首页静态展示数据（仅用于页面视觉呈现，不含任何接口请求）
// 站名：黑料网1

export const siteStats = [
  { label: '今日已更新', value: '386', unit: '条' },
  { label: '实时在线', value: '2.7', unit: '万' },
  { label: '在追专题', value: '54', unit: '个' },
  { label: '下次刷新', value: '3', unit: '分钟' },
];

export const heroImage =
  'https://readdy.ai/api/search-image?query=Stylized%20editorial%20abstract%20artwork%2C%20warm%20crimson%20and%20amber%20light%20beams%20over%20a%20minimalist%20newsroom%20desk%2C%20geometric%20paper%20shapes%2C%20magazine%20cover%20aesthetic%2C%20soft%20cinematic%20lighting%2C%20no%20text%2C%20high%20detail%2C%20warm%20neutral%20background&width=800&height=1000&seq=hl-hero-01&orientation=portrait';

export const liveTicker = [
  '某平台年度盛典彩排路透流出，主舞台临时切换第二套灯光方案',
  '新剧《雾港往事》首支预告上线，站内讨论量半小时破十万',
  '综艺《晚八点档》公布第三轮嘉宾阵容，录制时间顺延一周',
  '音乐节主办方回应退票进度：已开通第二批线下窗口',
  '短视频平台更新内容规范，涉及剧情演绎类账号需补标注',
  '黑料网1 今日头条已完成三次滚动更新',
  '都市剧《半城灯火》官宣定档，片方释出角色关系图',
  '某品牌秋冬发布会改线上直播，秀场布置提前曝光',
  '纪录片《追光者》第二季开播，首集聚焦幕后剪辑团队',
  '黑料网1新料快讯实时同步，蹲进展可开启页面自动刷新',
];

// 今日头条：大图主推
export const topHeadlines = [
  {
    id: 'top-1',
    tag: '今日头条',
    title: '年度盛典主舞台方案临时大改，第二套灯光设计抢先看',
    summary:
      '原定的环形主屏被替换成分层升降结构，舞美团队连夜加装两组追光。黑料网1最新整理出的彩排路透里，能看清换场时段的完整走位节奏。',
    image:
      'https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20a%20nighttime%20television%20studio%20stage%20with%20warm%20crimson%20spotlights%20and%20amber%20geometric%20light%20beams%2C%20abstract%20paper%20cut%20shapes%2C%20no%20text%2C%20magazine%20feature%20aesthetic%2C%20soft%20cinematic%20lighting%2C%20warm%20neutral%20background%2C%20high%20detail&width=1200&height=800&seq=hl-top-01&orientation=landscape',
    time: '18 分钟前',
    heat: '12.4 万',
  },
  {
    id: 'top-2',
    tag: '新料快讯',
    title: '新剧《雾港往事》预告释出，三处隐藏细节被观众逐帧翻出',
    summary:
      '首支预告全长 96 秒，片尾一闪而过的旧报纸被认出与主线案件有关。今日热搜里相关词条已经挤进前五。',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20editorial%20artwork%20of%20a%20misty%20harbor%20at%20dawn%20with%20warm%20amber%20and%20deep%20crimson%20glow%2C%20geometric%20silhouette%20shapes%2C%20stylized%20minimalist%20composition%2C%20no%20text%2C%20magazine%20feature%20aesthetic%2C%20warm%20neutral%20background%2C%20high%20detail&width=1200&height=800&seq=hl-top-02&orientation=landscape',
    time: '42 分钟前',
    heat: '8.6 万',
  },
];

// 侧栏速览
export const sideBriefs = [
  {
    id: 'brief-1',
    title: '综艺《晚八点档》第三轮阵容公布',
    time: '1 小时前',
    tag: '阵容',
  },
  {
    id: 'brief-2',
    title: '音乐节退票进度更新：第二批窗口已开',
    time: '2 小时前',
    tag: '回应',
  },
  {
    id: 'brief-3',
    title: '秋冬发布会改线上直播，秀场布置提前曝光',
    time: '3 小时前',
    tag: '片场',
  },
  {
    id: 'brief-4',
    title: '纪录片《追光者》第二季开播',
    time: '4 小时前',
    tag: '开播',
  },
];

// 新料快讯：密集时间线
export const quickFlash = [
  { time: '09:42', tag: '路透', title: '盛典换场空档被拍到两版提词器，台词顺序有调整' },
  { time: '09:28', tag: '定档', title: '都市剧《半城灯火》官宣开播日，角色关系图同步释出' },
  { time: '09:05', tag: '回应', title: '主办方补充说明退票流程，线下窗口延长开放三天' },
  { time: '08:51', tag: '预告', title: '《雾港往事》第二支物料预告上线时间锁定本周五' },
  { time: '08:37', tag: '综艺', title: '《晚八点档》第三轮录制地点更换，观众票改期说明发布' },
  { time: '08:20', tag: '现场', title: '音乐节舞台搭建进度过半，主屏造型从平面换成弧形' },
  { time: '07:58', tag: '开播', title: '《追光者》第二季首集上线，剪辑团队首次出镜' },
  { time: '07:31', tag: '榜单', title: '今日热搜前十里，影视相关词条占了四条' },
  { time: '07:10', tag: '快讯', title: '黑料网1 新料快讯完成本轮滚动，下轮预计整点更新' },
];

// 大图卡片流
export const bigCardFlow = [
  {
    id: 'card-1',
    category: '综艺',
    title: '年度盛典彩排次日：走位重排，开场改为群像长镜头',
    excerpt: '整套开场从单人特写改成群像调度，现场增加了两组移动机位。',
    image:
      'https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20a%20variety%20show%20studio%20set%20with%20warm%20amber%20and%20crimson%20stage%20lighting%2C%20abstract%20geometric%20shapes%2C%20no%20text%2C%20minimalist%20magazine%20aesthetic%2C%20warm%20neutral%20background%2C%20high%20detail&width=800&height=600&seq=hl-card-01&orientation=landscape',
    views: '4.2 万',
    comments: '318',
  },
  {
    id: 'card-2',
    category: '剧集',
    title: '《雾港往事》美术特辑：一条老街搭了整整两个月',
    excerpt: '从招牌字体到路边摊位，剧组按年代资料逐项还原。',
    image:
      'https://readdy.ai/api/search-image?query=Stylized%20editorial%20artwork%20of%20a%20retro%20city%20street%20set%20at%20dusk%20with%20warm%20amber%20lamps%20and%20crimson%20accents%2C%20abstract%20geometric%20buildings%2C%20no%20text%2C%20minimalist%20magazine%20aesthetic%2C%20warm%20neutral%20background%2C%20high%20detail&width=800&height=600&seq=hl-card-02&orientation=landscape',
    views: '3.7 万',
    comments: '264',
  },
  {
    id: 'card-3',
    category: '音乐',
    title: '音乐节主屏改造完成，弧形结构多出一层灯带',
    excerpt: '现场图显示主屏由平面改为弧形，两侧各加了一组升降灯架。',
    image:
      'https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20an%20outdoor%20music%20festival%20stage%20with%20warm%20amber%20and%20crimson%20lights%2C%20abstract%20geometric%20crowd%20shapes%2C%20no%20text%2C%20minimalist%20magazine%20aesthetic%2C%20warm%20neutral%20background%2C%20high%20detail&width=800&height=600&seq=hl-card-03&orientation=landscape',
    views: '5.1 万',
    comments: '402',
  },
  {
    id: 'card-4',
    category: '时尚',
    title: '秋冬发布会改线上直播，秀场布置提前曝光',
    excerpt: '品牌方把长走道压缩成环形，观众视角改为环绕式镜头。',
    image:
      'https://readdy.ai/api/search-image?query=Stylized%20editorial%20artwork%20of%20a%20minimalist%20fashion%20runway%20with%20warm%20amber%20light%20and%20crimson%20backdrop%2C%20abstract%20geometric%20shapes%2C%20no%20text%2C%20minimalist%20magazine%20aesthetic%2C%20warm%20neutral%20background%2C%20high%20detail&width=800&height=600&seq=hl-card-04&orientation=landscape',
    views: '2.8 万',
    comments: '196',
  },
  {
    id: 'card-5',
    category: '幕后',
    title: '纪录片《追光者》第二季：剪辑室成了第二主角',
    excerpt: '首集把镜头对准幕后团队，素材整理流程被完整记录。',
    image:
      'https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20a%20warm%20lit%20editing%20room%20with%20monitors%20and%20crimson%20amber%20glow%2C%20abstract%20geometric%20details%2C%20no%20text%2C%20minimalist%20magazine%20aesthetic%2C%20warm%20neutral%20background%2C%20high%20detail&width=800&height=600&seq=hl-card-05&orientation=landscape',
    views: '1.9 万',
    comments: '128',
  },
  {
    id: 'card-6',
    category: '现场',
    title: '盛典后台通道首次开放探班，候场区动线调整',
    excerpt: '候场区从单通道改成双向分流，进场顺序按节目单重排。',
    image:
      'https://readdy.ai/api/search-image?query=Stylized%20editorial%20artwork%20of%20a%20backstage%20corridor%20with%20warm%20amber%20strip%20lighting%20and%20crimson%20signs%2C%20abstract%20geometric%20perspective%2C%20no%20text%2C%20minimalist%20magazine%20aesthetic%2C%20warm%20neutral%20background%2C%20high%20detail&width=800&height=600&seq=hl-card-06&orientation=landscape',
    views: '3.3 万',
    comments: '241',
  },
];

// 热搜榜
export const hotSearch = [
  { rank: 1, title: '年度盛典第二套灯光方案', heat: '98.2 万', trend: 'up' },
  { rank: 2, title: '雾港往事预告隐藏细节', heat: '86.5 万', trend: 'up' },
  { rank: 3, title: '晚八点档第三轮阵容', heat: '71.3 万', trend: 'flat' },
  { rank: 4, title: '音乐节退票第二批窗口', heat: '63.8 万', trend: 'up' },
  { rank: 5, title: '半城灯火官宣定档', heat: '57.1 万', trend: 'up' },
  { rank: 6, title: '秋冬发布会改线上直播', heat: '49.6 万', trend: 'down' },
  { rank: 7, title: '追光者第二季开播', heat: '42.4 万', trend: 'flat' },
  { rank: 8, title: '盛典后台动线调整', heat: '35.9 万', trend: 'up' },
  { rank: 9, title: '音乐节弧形主屏', heat: '28.7 万', trend: 'down' },
  { rank: 10, title: '黑料网1 今日头条滚动更新', heat: '21.5 万', trend: 'up' },
];

// 专题合集
export const topicCollections = [
  {
    id: 'topic-1',
    name: '盛典全记录',
    count: 42,
    desc: '从彩排到正式开场，方案改动逐条对照',
    image:
      'https://readdy.ai/api/search-image?query=Stylized%20editorial%20cover%20art%20of%20stage%20lights%20in%20warm%20amber%20and%20crimson%2C%20abstract%20geometric%20rays%2C%20no%20text%2C%20minimalist%20magazine%20aesthetic%2C%20warm%20neutral%20background%2C%20high%20detail&width=600&height=400&seq=hl-topic-01&orientation=landscape',
  },
  {
    id: 'topic-2',
    name: '新剧物料室',
    count: 36,
    desc: '预告、花絮、定档消息统一归档',
    image:
      'https://readdy.ai/api/search-image?query=Stylized%20editorial%20cover%20art%20of%20stacked%20film%20reels%20and%20clapperboard%20in%20warm%20amber%20tones%2C%20abstract%20geometric%20composition%2C%20no%20text%2C%20minimalist%20magazine%20aesthetic%2C%20warm%20neutral%20background%2C%20high%20detail&width=600&height=400&seq=hl-topic-02&orientation=landscape',
  },
  {
    id: 'topic-3',
    name: '音乐节进行时',
    count: 28,
    desc: '阵容、票务、舞台进度实时汇总',
    image:
      'https://readdy.ai/api/search-image?query=Stylized%20editorial%20cover%20art%20of%20a%20festival%20stage%20silhouette%20with%20warm%20crimson%20and%20amber%20glow%2C%20abstract%20geometric%20shapes%2C%20no%20text%2C%20minimalist%20magazine%20aesthetic%2C%20warm%20neutral%20background%2C%20high%20detail&width=600&height=400&seq=hl-topic-03&orientation=landscape',
  },
  {
    id: 'topic-4',
    name: '幕后观察',
    count: 24,
    desc: '剪辑、美术、摄影组的日常一起看',
    image:
      'https://readdy.ai/api/search-image?query=Stylized%20editorial%20cover%20art%20of%20studio%20tools%20and%20geometric%20grid%20in%20warm%20amber%20and%20brown%2C%20abstract%20minimal%20composition%2C%20no%20text%2C%20minimalist%20magazine%20aesthetic%2C%20warm%20neutral%20background%2C%20high%20detail&width=600&height=400&seq=hl-topic-04&orientation=landscape',
  },
];

// 索引 / 合集（辅助侧重，放在醒目位置）
export const categoryIndex = [
  { name: '今日头条', count: 128, tone: 'primary' },
  { name: '新料快讯', count: 96, tone: 'accent' },
  { name: '综艺', count: 74, tone: 'secondary' },
  { name: '剧集', count: 68, tone: 'primary' },
  { name: '音乐', count: 52, tone: 'accent' },
  { name: '时尚', count: 45, tone: 'secondary' },
  { name: '幕后', count: 39, tone: 'primary' },
  { name: '现场', count: 33, tone: 'accent' },
];

export const navLinks = [
  { label: '首页', href: '#top' },
  { label: '今日头条', href: '#headline' },
  { label: '新料快讯', href: '#flash' },
  { label: '索引合集', href: '#index' },
  { label: '热搜榜', href: '#hot' },
  { label: '专题', href: '#topic' },
];